import { Plus } from "lucide-react";
import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface AddableListProps {
  subheaderText: string;
  onAddClick: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

const AddableList: React.FC<AddableListProps> = ({
  subheaderText,
  onAddClick,
  children,
  disabled = false,
  className,
}) => {
  return (
    <div
      className={cn(
        "rounded-md border border-input overflow-hidden",
        disabled && "opacity-50 pointer-events-none",
        className,
      )}
    >
      <div className="flex items-center justify-between border-b border-input bg-muted/30 pl-3 pr-1.5 py-1.5">
        <span className="text-sm font-semibold">{subheaderText}</span>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          onClick={onAddClick}
          disabled={disabled}
          aria-label={`Add ${subheaderText}`}
        >
          <Plus className="size-4" />
        </Button>
      </div>
      {React.Children.count(children) > 0 && (
        <div className="flex flex-col divide-y divide-input/60 [&>*]:px-3 [&>*]:py-1.5">
          {children}
        </div>
      )}
    </div>
  );
};

export default AddableList;
